import React from 'react';
import {
	Grid,
	Box,
	Button,
	Typography
} from '@mui/material';
import {
	useModalContext,
	useCalculatorContext,
	useSnackbarContext
} from '../../utilities';
import { useNavigate } from 'react-router-dom';

export const DeleteCalculatorPrompt = ( {calculator} ) => {
	const { closeModal } = useModalContext();
	const { showSnackbar } = useSnackbarContext();
	const { update, setUpdate, deleteCalculator } = useCalculatorContext();
	const navigate = useNavigate();

	const handleDelete = async () => {
		let res = await deleteCalculator(calculator.calculatorId);
		if (res && res.status === 200) {
			setUpdate(!update);
			return navigate('/myCalculators');
		} else {
			showSnackbar('Error - Calculator NOT deleted', 'error');
		}
		closeModal();
	};

	return (
		<Box>
			<Grid container justifyContent='center' spacing={2}>
				<Grid item xs={12} textAlign='center'>
					<Typography>Do you want to permanently delete <br /><b>{calculator.calculatorName}</b>?</Typography>
				</Grid>
				<Grid item>
					<Button variant='contained' color='warning' onClick={handleDelete}>delete</Button>
				</Grid>
				<Grid item>
					<Button variant='contained' onClick={closeModal}>cancel</Button>
				</Grid>
			</Grid>
		</Box>
	);
};
